export default __webpack_public_path__ + "static/media/element_72.7935b54f.avif";